<header class="app-header flex align-items-center justify-content-between gap-3">
  <div class="header-start flex align-items-center gap-3">
    <button class="icon-button mobile-menu-button" type="button" aria-label="Open navigation" (click)="menuToggle.emit()"><i class="pi pi-bars"></i></button>
    <a class="brand-home flex align-items-center gap-3" routerLink="/user-management/list" aria-label="Go to dashboard">
      <div class="brand-mark" aria-label="Government of India logo placeholder"><img _ngcontent-ng-c3282502621="" src="/assets/india-emblem.png" alt="Indian Emblem" style="width: 36px;"></div>
      <div class="brand-copy flex flex-column"><strong>Government of India</strong><b>UNIFIED ACCOUNTING SOFTWARE</b></div>
    </a>
  </div>
  <div class="header-title"></div>
  <div class="header-end flex align-items-center gap-3">
    <div class="header-clock"><span class="header-date-label">Current date &amp; time</span><strong>{{ currentDateTimeText() }}</strong></div>
    <button class="icon-button notification-button" type="button" aria-label="Notifications"><i class="pi pi-bell"></i><span class="notification-dot"></span></button>
    <button class="profile-button" type="button" aria-label="User profile"><span class="avatar">{{ userInitials() }}</span><span class="profile-copy"><strong>Welcome, {{ currentUserName() }}</strong><small>Administrator</small></span><i class="pi pi-chevron-down"></i></button>
    <button class="logout-button" type="button" (click)="logout.emit()">
      <i class="pi pi-sign-out"></i>
      <span>Logout</span>
    </button>
  </div>
</header>
